module.exports = __webpack_public_path__ + "static/media/HI-CAP.5a342169.pdf";